import { useEffect, useRef } from "react";
import "./LoadingDoorComponent.css";

import soundWoosh from '../../assets/audios/woosh.mp3';

//ORLA NOTES, vamos a empezar por simplificar este componente, deberiamos solo abrirlo y cerrarlo
//sin estar atado a logicas de juego?

const LoadingDoorComponent = ({ open }) => {
    const doorRef = useRef();

    let sound;

    const playSoundWoosh = (isPlay) => {
        if (!sound || sound.ended) {
            sound = new Audio(soundWoosh);
            if (!isPlay) {
                sound.play();
            } else {
                sound.pause();
            }
        }
    };

    useEffect(() => {
        playSoundWoosh(open);
    }, [open]);


    /*
    const lastState = useMemo(() => {
        return game?.previousStates?.length > 0 ? game.previousStates[game.previousStates.length - 1] : null;
    }, [game?.previousStates]);

    const message = useMemo(() => getMessageForTransition(lastState, game?.state), [lastState, game?.state]);

    
    useEffect(() => {
        if (game?.state) {
            toggleDoor();
        }
    }, [game?.state]);
  

    const toggleDoor = () => {
        if (doorRef.current) {
            // Cierra la puerta
            doorRef.current.classList.remove("open");
            doorRef.current.classList.add("close");

            // Abre la puerta después de 3 segundos
            setTimeout(() => {
                doorRef.current.classList.remove("close");
                doorRef.current.classList.add("open");
            }, 3000);
        }
    };
    */

    return (
        <div ref={doorRef} className={"door " + (open ? "open" : "close")}>
            <div className="box-l">
                <div className="zig-zag-line"></div>
            </div>
            <div className="box-r">
                <div className="zig-zag-line"></div>
            </div>
        </div>
    );
};

export default LoadingDoorComponent;
